module.exports = __webpack_public_path__ + "img/Weapon_150.029e3054.png";